import React, {cloneElement, Children, Component} from 'react'
import PropTypes from 'prop-types'
import { speed } from 'jquery';

class Rotation extends Component { 

  hovered = false

  state = {
    current: 0,
    acc: 0,
    speed: 0,
    fr: 0.92,
    targetDegree: 0,
    autoPlay: false,
    updateId: {},
    fpsInterval: 1000 / 5 // 5 fps
  }

  update(){
    
    if(!this._isMounted)
    {
        return; 
    }
    
    requestAnimationFrame(() => this.update());
    
    this.now = Date.now();
    this.elapsed = this.now - this.then;

    
    this.then = this.now - (this.elapsed % this.state.fpsInterval)

    if(this.elapsed > this.state.fpsInterval){
      if(this.state.autoPlay){
      
          /*console.log('velocity test update: ',
          Math.abs(this.state.current * 144 / (this.props.children.length || 1) + this.state.speed - this.state.targetDegree),
          '<=',
          Math.min(24, (this.props.is180 ? 0.5 : 1) * 144 / (this.props.children.length || 1))
          )*/
          
          
          if(Math.abs(this.state.speed) === 0 || 
          Math.abs(this.state.current * 144 / (this.props.children.length || 1) + this.state.speed - this.state.targetDegree) <= Math.min(24, (this.props.is180 ? 0.5 : 1) * 144 / (this.props.children.length || 1))){
            this.setState({
              autoPlay: false,
              speed: 0
            })
            this.props.onRotationEnded();
          }
      } else {
        this.setState(prevState => ({ speed: prevState.speed * prevState.fr }))     
      }      
    }
    if(this.elapsed > this.state.fpsInterval){

      this.setCurrentFrame((this.state.current + (-1) * Math.round(this.state.speed))/* % (this.props.children.length || 1)*/)
    } 
  }

  moveTo(deg){

    if(!this._isMounted){
      return;
    }
    
    this.setState({
      autoPlay: true,
      targetDegree: deg
    }, 
    () => {
      this.setState(prevState => ({
        acc: prevState.acc * prevState.fr,
        speed: Math.abs(this.state.targetDegree - Math.round(this.state.current)) <= Math.abs(this.state.targetDegree - 144 - Math.round(this.state.current)) ?
          Math.sign(prevState.targetDegree - Math.round(prevState.current))// * prevState.fr
          :
          Math.sign(this.state.targetDegree - 144 - Math.round(this.state.current)) //* prevState.fr
      })) 
    })
  }

  componentDidMount () {

    this._isMounted = true;

    let canvas = document.getElementById('canvas-content') 
    canvas.addEventListener('touchstart', this.touchStart);
    canvas.addEventListener('touchmove', this.touchMove);
    canvas.addEventListener('touchend', this.touchEnd);
    canvas.addEventListener('mousedown', this.touchStart);
    canvas.addEventListener('mousemove', this.touchMove);
    document.addEventListener('mouseup', this.touchEnd, false)

    /*if (this.props.autoPlay) {
      this.nextFrame()
    }*/
    
    this.then = Date.now();
    this.now = 0;
    this.elapsed = 0;

    var updateId = requestAnimationFrame(() => this.update());
    this.setState({updateId: updateId})
    
  }

  componentDidUpdate(prevProps){

    if(!this._isMounted){
      return;
    }
    
    if(prevProps.children.length < this.props.children.length){
      
      switch(this.props.children.length){
        case 6:
          this.setState({
            fr: 0.8,
            fpsInterval: 1000 / 6
          })
        break;
        case 12:
          this.setState({
            fr: 0.7,
            fpsInterval: 1000 / 5
          })
          break;
        case 24:
          this.setState({
            fr: 0.74,
            fpsInterval: 1000 / 24
          })
          break;
        case 36:
            this.setState({
              fr: 0.86,
              fpsInterval: 1000 / 30
            })
            break;
        case 72:
          this.setState({
            fr: 0.86,
            fpsInterval: 1000 / 30
          })
          break;
        case 144:
          this.setState({
            fr: 0.92,
            fpsInterval: 1000 / 60
          })
          break;
      }
      
      if( prevProps.children.length > 0 /*this.props.children.length > prevProps.children.length*/)
      {
        
        this.setState({
          current: Math.floor(this.state.current / prevProps.children.length * this.props.children.length)
        })
      } else {
        //console.log('initframe: ', this.props.initFrame)
        /*if(this.props.is180 && this.props.initFrame !== undefined && this.props.initFrame !== -1){
          //if(this.props.children[0].props.src.indexOf('Huerta') === -1){
          console.log('[set frame to]: ', Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
          this.setCurrentFrame(Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
          //this.setCurrentFrame(Math.floor(this.props.children.length / 2))
          //console.log(Math.floor(this.props.children.length / 2), this.props.children.length)
          
          //}
          
          //this.setCurrentFrame(Math.floor(this.props.children.length / 2))
          
        } else if (this.props.initFrame !== -1){
          this.setCurrentFrame(Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
        }*/
      }
      
    }
  }

  componentWillReceiveProps ({autoPlay}) {
    /*
    if (autoPlay !== this.props.autoPlay) {
      if (autoPlay) {
        //this.nextFrame()
      } else {
        //this.stop()
      }
    }*/
  }

  componentWillUnmount () {
    this._isMounted = false;

    document.removeEventListener('mouseup', this.touchEnd, false)
    this.stop()
  }

  setCurrentFrame (frame) {

    if(!this._isMounted){
      return;
    }
    
    const {cycle, children, onChange} = this.props
    const length = children.length
    let current = frame

    if (current - this.state.speed < 0) {
      current = cycle ? length - 1: 0
    }

    /*if(this.props.is180 && this.props.initFrame !== undefined){
      console.log('c + s: ', current + Math.sign(this.state.speed), 's: ', this.state.speed, 'cycle: ', cycle)
    }*/
    if (current - Math.sign(this.state.speed) >= length - 1) {
      //console.log('wtf')
      current = cycle ? current % (length || 1) : length - 1;
      if(!cycle){
        this.setState({
          speed: 0
        })
      }
      
    }

    if (current !== this.state.current) {
      this.setState({current})
      
      /*if(this.props.is180 && this.props.initFrame !== undefined){
        //console.log('is180? ', this.props.is180, 'changed to: ', current, 'of', length)
      }*/
      
      onChange(current)

    } else if (this.props.autoPlay) {
      this.stop()
    }
  }

  nextFrame () {
    const {current} = this.state
    const {reverse, autoPlay, pauseOnHover} = this.props
    const playTimeout = autoPlay === true ? 75 : autoPlay

    if (!this.hovered || !pauseOnHover) {
      this.setCurrentFrame(reverse ? current - 1 : current + 1)
    }

    this.nextTimeout = setTimeout(() => {
      this.nextFrame()
    }, playTimeout)
  }

  stop () {
    clearTimeout(this.nextTimeout)
  }

  hover = event => {
    this.hovered = true
  }

  unhover = event => {
    this.hovered = false
  }

  wheelMove = event => {

    // TODO: implement zoom
    /*event.preventDefault()
    const {deltaY} = event
    const {reverse} = this.props
    const {current} = this.state
    const delta = deltaY === 0 ? 0 : deltaY / Math.abs(deltaY)
    this.stop()
    this.setCurrentFrame(reverse ? current - delta : current + delta)*/
  }

  touchStart = event => {
    if(!this._isMounted){
      return;
    }
    if(this.state.autoPlay){
      return;
    }
    event.preventDefault()
    this.pointerPosition = this.calculatePointerPosition(event)
    this.startFrame = this.state.current
    this.stop()
  }

  touchMove = event => {
    if(!this._isMounted){
      return;
    }

    if(this.state.autoPlay){
      return;
    }

    const notTouched = typeof this.pointerPosition !== 'number'
    event.preventDefault()

    if (notTouched) {
      return
    }

    const {vertical, children, reverse} = this.props
    //const {offsetWidth, offsetHeight} = event.currentTarget
    const pointer = this.calculatePointerPosition(event)
    //const max = vertical ? offsetHeight : offsetWidth
    const offset = (pointer - this.pointerPosition) / 8
    //console.log('offset',offset);

    // set speed based on pointer offset
    //console.log("child count: ", this.props.children.length)
    //console.log("offset: ", offset, "Sign: ", Math.sign(offset), "round: ", -Math.round(Math.sign(offset)), "speed: ", (-Math.round(Math.sign(offset) * Math.round(this.props.maxspeed / 2))));

    if(this.props.children.length === 12){
      this.setState(prevstate => ({
        acc: -(Math.sign(offset)) * .75,
        speed: -(Math.sign(offset)) * .75/*-Math.round(Math.sign(offset) * Math.round(this.props.maxspeed / 2))*/
      }), function(){
        //console.log('final speed:', this.state.speed)
      })
    } else {
      this.setState(prevstate => ({
        acc: -Math.sign(offset) * Math.round(this.props.maxspeed / 2) / 10,
        speed: prevstate.speed + this.state.acc /*-Math.round(Math.sign(offset) * Math.round(this.props.maxspeed / 2))*/
      }), function(){
        //console.log('final speed:', this.state.speed)      
      })
    }
    
    this.pointerPosition = this.calculatePointerPosition(event)
    this.startFrame = this.state.current
    //const delta = Math.floor(offset / max * children.length)
    //this.setCurrentFrame(reverse ? this.startFrame - delta : this.startFrame + delta)
  }

  touchEnd = event => {
    if(!this._isMounted){
      return;
    }
    if(this.state.autoPlay){
      return;
    }
    event.preventDefault()
    this.pointerPosition = null
    this.startFrame = null
  }

  pressKey = event => {
    const eventOnField = event.target.tagName.match('TEXTAREA|INPUT|SELECT')

    if (eventOnField) {
      return
    }

    const {current} = this.state
    const {vertical, reverse} = this.props
    const prevKey = vertical ? 38 : 37
    const nextKey = vertical ? 40 : 39
    this.stop()

    if (event.keyCode === prevKey) {
      this.setCurrentFrame(reverse ? current + 1 : current - 1)
    } else if (event.keyCode === nextKey) {
      this.setCurrentFrame(reverse ? current - 1 : current + 1)
    }
  }

  calculatePointerPosition (event) {
    const {clientX, clientY} = event.type.indexOf('touch') === 0 ? event.changedTouches[0] : event
    const {offsetTop, offsetLeft} = event.currentTarget
    return this.props.vertical ? clientY - offsetTop : clientX - offsetLeft
  }

  render () {

    if(!this._isMounted){
      return <div></div>;
    }

    const {current} = this.state

    const {
      children,
      className,
      tabIndex,
      scroll,
      pauseOnHover
    } = this.props

    return (
      <div
        tabIndex={tabIndex}
        /*onTouchStart={this.touchStart}
        onTouchMove={this.touchMove}
        onTouchEnd={this.touchEnd}
        onMouseDown={this.touchStart}
        onMouseMove={this.touchMove}*/
        onWheel={scroll ? this.wheelMove : null}
        onMouseEnter={pauseOnHover ? this.hover : null}
        onMouseLeave={pauseOnHover ? this.unhover : null}
        onKeyDown={tabIndex >= 0 ? this.pressKey : null}
        className={className}
        style={{position: 'relative'}}
        id="rotation-controller"
        >        
        {Children.map(children, (child, i) => cloneElement(
          child,
          {
            style: {
              width: '100%',
              display: current === i ? 'block' : 'none',
              willChange: 'visibility'
            }
          }
        ))}
      </div>
    )
  }
}

Rotation.propTypes = {
  className: PropTypes.string,
  cycle: PropTypes.bool,
  speed: PropTypes.number,
  maxspeed: PropTypes.number,
  scroll: PropTypes.bool,
  vertical: PropTypes.bool,
  reverse: PropTypes.bool,
  autoPlay: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number
  ]),
  onChange: PropTypes.func,
  onRotationEnded: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  tabIndex: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  pauseOnHover: PropTypes.bool
}

Rotation.defaultProps = {
  cycle: false,
  speed: 1,
  maxspeed: 1,
  scroll: true,
  vertical: false,
  tabIndex: 0,
  autoPlay: false,
  pauseOnHover: false,    
  onChange: () => {},
  onRotationEnded: () => {}
}

export default Rotation;
